import React from "react";
import { connect } from "react-redux";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import { MenuProps } from "antd/es/menu";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { isCurrentUserReadOnly } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./AddOrCreateDropdown.module.scss";

const messages = defineMessages({
  add: {
    id: "preview.addOrCreateDropdown.add",
    defaultMessage: "Add",
    description: "Add dropdown text",
  },
  addExisting: {
    id: "preview.addOrCreateDropdown.addExisting",
    defaultMessage: "Add Existing",
    description: "Add existing text",
  },
  addNew: {
    id: "preview.addOrCreateDropdown.addNew",
    defaultMessage: "Add New",
    description: "Add new text",
  },
  changePrimary: {
    id: "preview.addOrCreateDropdown.changePrimary",
    defaultMessage: "Change Primary",
    description: "Change Primary button text",
  },
  setPrimary: {
    id: "preview.addOrCreateDropdown.setPrimary",
    defaultMessage: "Set Primary",
    description: "Set Primary button text",
  },
  unsetPrimary: {
    id: "preview.addOrCreateDropdown.unsetPrimary",
    defaultMessage: "Unset Primary",
    description: "Unset Primary button text",
  },
});

interface Props {
  disabled?: boolean;
  isReadOnlyMember: boolean;
  loading?: boolean;
  onAddExisting?: () => void;
  onAddNew?: () => void;
  onChangePrimary?: () => void;
  onUnsetPrimary?: () => void;
  showPrimary?: boolean;
}

const AddOrCreateDropdown: React.FC<Props> = ({
  disabled,
  isReadOnlyMember,
  loading,
  onAddExisting,
  onAddNew,
  onChangePrimary,
  onUnsetPrimary,
  showPrimary,
}) => {
  const intl = useIntl();

  const items: MenuProps["items"] = [
    {
      key: "addNew",
      label: intl.formatMessage(messages.addNew),
      onClick: onAddNew,
    },
    {
      key: "addExisting",
      label: intl.formatMessage(messages.addExisting),
      onClick: onAddExisting,
    },
    ...(showPrimary
      ? onUnsetPrimary
        ? [
            {
              className: styles.primary,
              key: "changePrimary",
              label: intl.formatMessage(messages.changePrimary),
              onClick: onChangePrimary,
            },
            {
              key: "unsetPrimary",
              label: intl.formatMessage(messages.unsetPrimary),
              onClick: onUnsetPrimary,
            },
          ]
        : [
            {
              className: styles.primary,
              key: "setPrimary",
              label: intl.formatMessage(messages.setPrimary),
              onClick: onChangePrimary,
            },
          ]
      : []),
  ];

  return (
    <Dropdown
      disabled={disabled || isReadOnlyMember}
      menu={{ items }}
      overlayClassName={styles.dropdown}
    >
      <Button loading={loading} rightIcon={<FontAwesomeIcon icon={faAngleDown} />} type="link">
        {intl.formatMessage(messages.add)}
      </Button>
    </Dropdown>
  );
};

const mapStateToProps = (state: RootState) => ({
  isReadOnlyMember: isCurrentUserReadOnly(state),
});

export default connect(mapStateToProps)(AddOrCreateDropdown);
